class AboutSourceCarousel {
  constructor(element) {
    this.element = element;
    this.slides = Array.from(element.querySelectorAll('[data-carousel-slide]'));
    this.dots = Array.from(element.querySelectorAll('[data-carousel-dot]'));
    this.previous = element.querySelector('[data-carousel-previous]');
    this.next = element.querySelector('[data-carousel-next]');
    this.currentIndex = this.slides.findIndex((slide) => !slide.hidden);

    if (this.slides.length < 2) return;

    this.element.dataset.aboutCarouselInitialized = 'true';

    this.previous?.addEventListener('click', () => this.show(this.currentIndex - 1));
    this.next?.addEventListener('click', () => this.show(this.currentIndex + 1));
    this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.carouselDot))));
    this.element.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') this.show(this.currentIndex - 1);
      if (event.key === 'ArrowRight') this.show(this.currentIndex + 1);
    });
  }

  show(index) {
    this.currentIndex = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, slideIndex) => {
      slide.hidden = slideIndex !== this.currentIndex;
    });
    this.dots.forEach((dot, dotIndex) => {
      if (dotIndex === this.currentIndex) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }
}

const initialiseAboutCarousels = (container = document) => {
  container.querySelectorAll('[data-about-carousel]').forEach((element) => {
    if (!element.dataset.aboutCarouselInitialized) new AboutSourceCarousel(element);
  });
};

document.addEventListener('DOMContentLoaded', () => initialiseAboutCarousels());
document.addEventListener('shopify:section:load', (event) => initialiseAboutCarousels(event.target));
